/**
 * Location storage frame side enum
 * ---
 * @enum string
 * @readonly
 */
export const E_LocationStorage_Frame_Side = {
	FRONT: "FRONT",
	BACK: "BACK"
};

/**
 * Location storage frame type enum
 * ---
 * @enum string
 * @readonly
 */
export const E_LocationStorage_Frame_Type = {
	FOUR_RECTANGLES: "FOUR_RECTANGLES",
	SINGLE_UNIT: "SINGLE_UNIT",
	BIKE_BOX: "BIKE_BOX",
	TERMINAL: "TERMINAL",
};

export const E_LocationStorage_Block_Type = {
	QUINTUPLE_VERTICAL: "QUINTUPLE_VERTICAL",
	QUADRUPLE_VERTICAL: "QUADRUPLE_VERTICAL",
	TRIPLE_VERTICAL: "TRIPLE_VERTICAL",
	DOUBLE_VERTICAL: "DOUBLE_VERTICAL",
	SINGLE: "SINGLE",
}
